import React from "react";

import "./CommentsSection.css";
import CommentItem from "./CommentItem";
import RichCommentEditor from "./RichCommentEditor";
import { getProfileDisplayName } from "./commentUtils";

export default function CommentsSection({
  comments = [],
  profile,
  onSubmit,
  title,
  placeholder = "Comments",
  addButtonLabel = "Add Comment",
  showTitle = true,
  titleClassName = "font-semibold mb-3 text-[#3b3b3b]",
  titleAs: TitleTag = "h3",
  wrapperClassName = "",
  inputBgClass = "bg-[#EEF0ED]",
  itemClassName = "bg-[#EEF0ED] p-4 rounded-[5px] text-gray-600 mb-4",
  useGradientButton = false,
  unknownUserLabel = "Unknown User",
  dateFormat = "MM/DD/YYYY HH:mm:ss",
}) {
  const editorProfile = {
    avatar: profile?.avatar,
    displayName: getProfileDisplayName(profile),
  };

  const list = Array.isArray(comments) ? comments : [];

  return (
    <div className={`rabo-comments-section ${wrapperClassName}`.trim()}>
      {showTitle && title ? (
        <TitleTag className={titleClassName}>{title}</TitleTag>
      ) : null}

      <RichCommentEditor
        profile={editorProfile}
        placeholder={placeholder}
        submitLabel={addButtonLabel}
        inputBgClass={inputBgClass}
        useGradientButton={useGradientButton}
        onSubmit={onSubmit}
      />

      {list.length > 0 &&
        list.map((comment, index) => (
          <CommentItem
            key={comment.CommentID || index}
            comment={comment}
            itemClassName={itemClassName}
            dateFormat={dateFormat}
            unknownUserLabel={unknownUserLabel}
          />
        ))}
    </div>
  );
}
